import { useQuery } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

export function usePlaneSpottersImage(registration: string | undefined) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(
    orpc.planespotters.getAircraftImage.queryOptions({
      input: { registration: registration ?? '' },
      enabled: !!registration,
      staleTime: 24 * 60 * 60 * 1000, // 24 hours
      gcTime: 24 * 60 * 60 * 1000,
    })
  )
}
